import * as actions from './actions';
import { DEFAULT_CROSS_CUTTING_TASK } from './const';
import * as getters from './getters';
import * as mutations from './mutations';

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state: {
    crossCuttingTask: DEFAULT_CROSS_CUTTING_TASK,
  },
};
